var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "append-to-body": "",
          },
          on: {
            open: _vm.open,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { attrs: { prop: "product_name" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("产品名称")]),
                  ]),
                  _c("v-input", {
                    attrs: { type: "text", name: "model" },
                    model: {
                      value: _vm.ruleForm.product_name,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "product_name", $$v)
                      },
                      expression: "ruleForm.product_name",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "product_type" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("产品类型")]),
                  ]),
                  _c("v-select", {
                    attrs: {
                      id: "product_type",
                      name: "product_type",
                      options: _vm.productTypeOptins,
                    },
                    model: {
                      value: _vm.ruleForm.product_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "product_type", $$v)
                      },
                      expression: "ruleForm.product_type",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "recursion" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("认证方式")]),
                  ]),
                  _c("v-radio", {
                    staticClass: "options",
                    attrs: { name: "authStyle", options: _vm.authStyleOptions },
                    model: {
                      value: _vm.ruleForm.auth_style,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "auth_style", $$v)
                      },
                      expression: "ruleForm.auth_style",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { attrs: { prop: "link_type" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("连接类型")]),
                  ]),
                  _c("v-select", {
                    attrs: {
                      id: "link_type",
                      name: "link_type",
                      options: _vm.linkOptins,
                    },
                    model: {
                      value: _vm.ruleForm.link_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "link_type", $$v)
                      },
                      expression: "ruleForm.link_type",
                    },
                  }),
                ],
                2
              ),
              _vm.ruleForm.link_type == "gateway"
                ? _c(
                    "v-form-item",
                    { attrs: { prop: "sub_product_key" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("span", { staticClass: "required" }, [_vm._v("*")]),
                        _c("span", [_vm._v("子设备产品")]),
                      ]),
                      _c("v-select", {
                        attrs: {
                          id: "sub_product_key",
                          name: "sub_product_key",
                          options: _vm.linkproductOptins,
                        },
                        model: {
                          value: _vm.ruleForm.sub_product_key,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "sub_product_key", $$v)
                          },
                          expression: "ruleForm.sub_product_key",
                        },
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("v-loading", {
            staticClass: "loading-box",
            attrs: { visible: !_vm.upTips, name: "loading4" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }